<div class="ni-stream">
  <div class="ni-filters">
    <label><input type="checkbox" [(ngModel)]="unreadOnly"> unread only</label>
    <select [(ngModel)]="sourceFilter">
      <option value="">all sources</option>
      <option value="blog">blogs &amp; news</option>
      <option value="youtube">youtube</option>
      <option value="reddit">reddit &amp; hn</option>
    </select>
  </div>

  <p class="ni-msg" *ngIf="loading">Fetching feeds&hellip;</p>
  <p class="ni-err" *ngIf="errorCount">
    {{ errorCount }} feed(s) failed to load &mdash; see the Feeds tab.
  </p>
  <p class="ni-msg" *ngIf="!loading && visibleItems.length === 0">
    Nothing here. Add feeds in the Feeds tab, or loosen your filters.
  </p>

  <app-ni-feed-item *ngFor="let item of visibleItems; trackBy: trackByHash"
    [item]="item"
    (open)="open.emit(item)"
    (toggleLike)="toggleLike.emit(item)"></app-ni-feed-item>
</div>
